import React from 'react';
import WorkflowListPage from '../components/Workflow/List';

const WorkflowPage = () => {
  return <div><WorkflowListPage /></div>; 
};

export default WorkflowPage;
